













































import { mixins, Component, Prop } from 'nuxt-property-decorator';

import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import ReferralPrizeMixin from './referralPrizeMixin';

import SendReferralInvite from '~/apollo/mutations/SendReferralInvite.mutation';
import { copyToClipboard } from '~/components/utils/browser/copy';

import ArrowRightIcon from '~/assets/svg/arrow-right-rounded.vue.svg';
import LinkIcon from '~/assets/svg/link-chain.vue.svg';
import ScoreIcon from '~/assets/svg/score.vue.svg';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';

@Component({
  components: {
    ArrowRightIcon,
    BravadoText,
    BravadoTextInputV3,
    LinkIcon,
    ScoreIcon,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
})
export default class ReferralInvite extends mixins(ReferralPrizeMixin) {
  @Prop({ type: Boolean, default: false }) boxedInvite?: boolean;
  @Prop({ default: true, type: Boolean }) hasActionSection?: boolean;
  @Prop({ default: 'body' }) textVariant?: 'body' | 'body-semibold' | 'subhead' | 'subhead-semibold';
  @Prop({ default: 1000 }) prize!: number;
  @Prop({ default: 'referral__menu' }) eventName!: string;

  readonly baseUrl: string = process.env.internalBaseUrl;

  isSending = false;
  formSubmitted = false;
  form = {
    email: '',
  };

  get referralUrl() {
    return `${this.baseUrl}/?mrk=${this.$auth.user.superInviteMarker}`;
  }

  /* get moneyPrize() {
    return transformIntoMoney(this.prize);
  } */

  get inviteActionClasses() {
    return {
      'referral-invite-action--boxed': this.boxedInvite,
    };
  }

  get isFormValid() {
    if (this.$v.form.email?.$dirty) {
      return !this.$v.$invalid;
    } else {
      return true;
    }
  }

  handleBlur(e: { target: { value: string } }) {
    if (e.target.value) {
      this.$v.$touch();
    }
  }

  async copyInvite() {
    this.$analytics.logEvent(`${this.eventName}__copy-button__click`);

    try {
      await copyToClipboard(this.referralUrl);
      this.$notice.success('The link has been copied to clipboard');
    } catch (e) {
      this.$notice.error('The link has not been copied to clipboard', e as Error);
    }
  }

  async handleSendInvite() {
    this.formSubmitted = true;
    if (this.isSending || this.$v.$invalid) {
      return;
    }

    this.$v.$touch();

    try {
      this.$analytics.logEvent(`${this.eventName}__send-email__click`);

      this.isSending = true;

      await this.$apollo.mutate({
        mutation: SendReferralInvite,
        variables: {
          input: {
            email: this.form.email,
          },
        },
      });

      this.$notice.success("You've successfully sent the invite");

      this.form.email = '';
      this.$v.$reset();
    } catch (e) {
      this.$notice.error("You can't invite this email. Already a Bravado user");
    } finally {
      this.isSending = false;
    }
  }
}
